const parseTransformation = t => {
    let [a, b, c, d, x, y] = t;
    return `matrix(${a},${b},${c},${d},${x},${y})`;
};

const parseProps = props => {
    let parsedProps = {};
    
    parsedProps.transform = props.transform && parseTransformation(props.transform);
    parsedProps.width = props.width && `${props.width}px`;
    parsedProps.height = props.height && `${props.height}px`;

    return parsedProps;
};

function Text(props) {
    const { boxProps, textProps, textValue, opacity } = props;
    const [boxStyle, textStyle] = [boxProps, textProps].map(p => parseProps(p));
    
    return (
        <div style={{ ...boxStyle, opacity }} className='aux-text'>
            <div style={textStyle} className="text">
                {textValue}
            </div>
        </div>
    );
}

export default Text;